import moment from "moment";

import {
	baseFields,
	personFields,
	addressFields,
	contactFields,
	accessFields,
	fieldMapper
} from "./fields";
import {
	observeValidators,
	setFieldListeners,
	setInputsMask,
	setNotRequiredFields,
	convertMaskedDate
} from "./utils";
import PubSub from "pubsub-js";
import "../shared/pubsub-triggers";
import { setTimeout } from "timers";
import mapKeys from "lodash/mapKeys";
import { setBrasilianStates } from "./address";
import nanoajax from "nanoajax";
import { modalConstructor, closeModal } from "../vanilla/modal";
import {
	$,
	getCheckoutId,
	storeToken,
	requestSuccess,
	checkEmptyValue,
	redirectLoggedUser,
	verifyCheckoutId
} from "../vanilla/utils";
import { gaCrossCias, acessouLogin, registerSuccess } from "./trackUtils";
import { setAsInvalid } from "../shared/validation-utils";
import { loginUser } from "../login/login"
const jwtDecode = require("jwt-decode");

modalConstructor();

window.addEventListener("load", function() {
	window.facebookRegisterData = false;
	window.fb_try = 0;
	window.registerUserSubmit = e => {
		e.preventDefault();
		register();
	};
	getFBStatus();
	setInputsMask();
	observeValidators($("#form_register"));

	mapKeys(baseFields, setFieldListeners);
	mapKeys(personFields, setFieldListeners);
	mapKeys(addressFields, setFieldListeners);
	mapKeys(contactFields, setFieldListeners);
	mapKeys(accessFields, setFieldListeners);
	setNotRequiredFields();
	setBrasilianStates();

	$("#submit_register").disabled = false;
	$("#type_person").disabled = false;
	$("#type_company").disabled = false;
	$("#form_register").onsubmit = submitRegisterForm;

	verifyCheckoutId();
	gaCrossCias();
	acessouLogin();

	$("#type_person_label").addEventListener("click", function() {
		$("#form_register").reset();
	});

	$("#type_company_label").addEventListener("click", function() {
		$("#form_register").reset();
	});

	//TODO timout modal

	//TODO register errors
});

export const getFBStatus = () => {
	if (window.FB) {
		window.FB.getLoginStatus(function(response) {
			window.facebookLoginStatus = response.status;
			if (response.status === "connected") {
				window.facebookRegisterData = response.authResponse;
			}
		});
	} else {
		window.fb_try = window.fb_try + 1;
		setTimeout(() => {
			if (window.fb_try < 10) {
				getFBStatus();
			}
		}, 1000);
	}
}; 

export const loadingSubmit = submitting => {
	if (submitting) {
		$("#submit_register").disabled = true;
	} else {
		$("#submit_register").disabled = false;
		$("#btn_accept") && $("#btn_accept").classList.remove("btn--is-loading");
	}
};

export const submitRegisterForm = event => {
	$("#div-error").style.display = "none";
	if (typeof event !== "undefined") {
		event.preventDefault();
	}

	if (!focusInErrors()) {
		register();
	}
};

export const register = focusInErrors => {	
	const checkoutId = getCheckoutId();

	const getInputValue = inputName => {
		const inputToGet = document.getElementsByName(inputName)[0];
		return typeof inputToGet !== "undefined" ? inputToGet.value.replace(/  +/g, " ") : null;
	};

	loadingSubmit(true);

	

	let registerData = {
		type: $("#type_person").checked ? "f" : "j",
		address: getInputValue("register_address"),
		addressNumber: getInputValue("address_number"),
		addressComplement: getInputValue("address_complement"),
		addressNeighborhood: getInputValue("register_neighborhood"),
		addressCity: getInputValue("address_city"),
		addressState: getInputValue("address_state"),
		addressZipCode: getInputValue("register_cep"),
		email: getInputValue("email"),
		password: getInputValue("password"),
		// carrier1: getInputValue("carrier1"),
		// carrier2: getInputValue("carrier2"),
		phone1: getInputValue("phone1"),
		phone2: getInputValue("phone2"),
		optionId: getInputValue("register_quest"),
		checkoutId: checkoutId,
		termsAccepted: $("#terms").checked,
		provider: "maxmilhas"
	};

	registerData.phone2 = registerData.phone2;

	if ($("#type_person").checked) {
		registerData.name = getInputValue("register_name");
		registerData.cpf = getInputValue("cpf");
		registerData.gender = getInputValue("register_gender");
		registerData.birthday =
			getInputValue("register_birth") !== null
				? convertMaskedDate(getInputValue("register_birth"))
				: null;
	} else {
		registerData.companyName = getInputValue("company_name");
		registerData.fancyName = getInputValue("fancy_name");
		registerData.cnpj = getInputValue("cnpj");
		registerData.contactName = getInputValue("contact_name");
		registerData.inscricaoMunicipal = getInputValue("inscricao_municipal");
		registerData.iss =
			getInputValue("address_city") === "Belo Horizonte" && $("#iss_retido").checked;
	}

	const url = new URL(window.location.href);
	const facebookRegister = url.searchParams.get("facebook") == "true";


	if (window.facebookRegisterData && facebookRegister) {
		registerData.facebookResponse = JSON.stringify(window.facebookRegisterData);
	}

	let flow = checkoutId ? "compra" : "normal";

	nanoajax.ajax(
		{
			url: `/cadastro`,
			method: "POST",
			body: JSON.stringify(registerData),
			headers: { "Content-Type": "application/json" }
		},		
		(code, responseJSON) => {			
			try {
				const response = JSON.parse(responseJSON);
				if (requestSuccess(code)) {
					if (code === 201) {
						const user = jwtDecode(response.token);
						PubSub.publish("dataLayer", {
							event: "utmUser",
							idusers: user.id
						});

						registerSuccess(registerData.email, flow);

						if (!checkEmptyValue(response.affiliate_pixel)) {
							let pixel = response.affiliate_pixel;

							const firstIndex = pixel.indexOf("<") + 1;
							const secondIndex = pixel.indexOf(">");
							const tagName = pixel.substring(firstIndex, secondIndex);

							const pattern = `\<\/?${tagName}\>`;
							const r = new RegExp(pattern, "g");

							let tagNode = document.createElement(`${tagName}`);
							tagNode.id = "afiliates";

							pixel = pixel.replace(r, "");

							tagNode.innerHTML = pixel;

							$("#body").appendChild(tagNode);
						}
						storeToken(response.token);

						PubSub.publish("dataLayer", {
							event: "gaEvent",
							gaEventCategory: "Cadastro",
							gaEventAction: "Cadastrado com sucesso"
						});

						try {
							loginUser(registerData.email, registerData.password)
						} catch (e) {
							console.error(e);
						}

						redirectLoggedUser();
					}
				} else {
					if (response && response.details && response.details.errors) {
						setFieldErros(response.details.errors, focusInErrors);
					} else {
						setRegisterError();
					}
				}
				loadingSubmit(false);
			} catch (err) {
				setRegisterError();
				loadingSubmit(false);
			}
		}
	);
};

export const setRegisterError = () => {
	const divError = $("#div-error");
	divError.style.display = "flex";
	divError.innerHTML = `<div class="alert--icon">
                              <i class="icon-close"></i>
                        </div>
                        <div class="alert--message">
                              <p>Erro ao fazer cadastro. Verifique seus dados e tente novamente. </p>
                        </div>`;
	closeModal();
};

export const setFieldErros = (errors = {}, focus = true) => {
	Object.keys(errors).map(error => {
		if (errors[error].attr === "ssn") {
			setAsInvalid(
				$($("#type_person").checked ? "#cpf" : "cnpj"),
				errors[error].message || "Valor inválido."
			);
		} else {
			const field = fieldMapper[errors[error].attr];
			setAsInvalid($(`#${field}`), errors[error].message || "Valor inválido.");
		}
	});
	focus && focusInErrors();
};

export const focusInErrors = () => {
	const form = $("#form_register");
	const errors = form.querySelectorAll(".has-error .form-control");

	if (errors.length > 0) {
		setTimeout(
			() =>
				$("#form_register")
					.querySelector(".has-error .form-control")
					.focus(),
			1
		);
		return true;
	}

	return false;
};

export const setFieldInvalid = (field, message) => {
	setAsInvalid(field, message);
	field.setAttribute("hasBusinessError", "true");
};
